export default __webpack_public_path__ + "static/recent-postcard-4-012b4a11ae04c994ea02b63208d33c86.jpeg";